var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import PropTypes from "prop-types";
import { css } from "styled-components";
import { map } from "../../breakpoint";
import { pickColor } from "./colors";
var validBorderStyleValues = ["none", "hidden", "dotted", "dashed", "solid", "double", "groove", "inset", "ridge", "outset"];
export var border = function border(props) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
    var borderColor = _ref.borderColor;
    return map(borderColor, function (color) {
      return color && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          border-color: ", ";\n        "])), pickColor(color));
    });
  }, function (_ref2) {
    var borderWidth = _ref2.borderWidth;
    return map(borderWidth, function (val) {
      return val !== undefined && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          border-width: ", ";\n        "])), val);
    });
  }, function (_ref3) {
    var borderStyle = _ref3.borderStyle;
    return map(borderStyle, function (val) {
      return val && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          border-style: ", ";\n        "])), val);
    });
  });
};
export var borderStylePropType = PropTypes.oneOf(validBorderStyleValues);
export var borderStylePropTypeMap = PropTypes.oneOfType([borderStylePropType, PropTypes.shape({
  xs: borderStylePropType,
  sm: borderStylePropType,
  md: borderStylePropType,
  lg: borderStylePropType,
  xl: borderStylePropType,
  xxl: borderStylePropType,
  xxxl: borderStylePropType
})]);